export const DASHBOARD_FETCH_ORG_INFO_BEGIN = 'DASHBOARD_FETCH_ORG_INFO_BEGIN';
export const ERROR_SOMETHING_WENT_WRONG = "Sorry, something went wrong. Please try again.";
export const ERROR_EXPORT_ALERT_LIMIT_EXCEED = "The number of rows you are trying to export exceeds the limit. Please filter the results by Site and export.";
export const ERROR_PAGE_NOT_FOUND = "Page not found.";

